module.exports = __webpack_public_path__ + "img/search_black.4699055.png";